export type SecurityTypesProps = {
  hasControlledAccess: boolean;
  hasDoorman: boolean;
  hasGatedEntry: boolean;
  hasIntercom: boolean;
  hasNightPatrol: boolean;
};

const SecurityTypes = ({
  hasControlledAccess = false,
  hasDoorman = false,
  hasGatedEntry = false,
  hasIntercom = false,
  hasNightPatrol = false,
}: Partial<SecurityTypesProps> = {}): SecurityTypesProps => ({
  hasControlledAccess: Boolean(hasControlledAccess),
  hasDoorman: Boolean(hasDoorman),
  hasGatedEntry: Boolean(hasGatedEntry),
  hasIntercom: Boolean(hasIntercom),
  hasNightPatrol: Boolean(hasNightPatrol),
});

export default SecurityTypes;
